/**
 * All query keys are arrays generated from simple functions. It makes easy to find
 * any cached data by query key. For example:
 *
 * When fetching data from API we can set the queryKey as:
 * ```
 * getMyListQueryKey(filter1, filter2)
 * ```
 *
 * Then, when we need to find all entries from the cache for that specific queryKey,
 * we can do the following:
 * ```
 * const cachedResultsKey = getMyListQueryKey() // all data
 * const cachedResultsKey = getMyListQueryKey(filter1) // data filtered by filter1
 * const cachedResultsKey = getMyListQueryKey(filter1, filter2) // exact match
 * ```
 */

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import {
  SaleDestination,
  SaleNextAction,
  SaleSortBy,
} from './salesQueryParameter'

type SalesKeys = [
  page: number,
  status: string,
  hasRead?: boolean,
  expiredFrom?: string,
  order?: SaleSortBy,
  destination?: SaleDestination,
  nextAction?: SaleNextAction,
]

type StocklistSourcesKeys = [page: number, pageSize: number, status?: string]

type StocklistSourceKeys = [sourceQid: string]

type StocklistSourceOffersKeys = [
  sourceQid: string,
  page: number,
  pageSize: number,
  brands?: string[],
  ordering?: string,
]

export const getPrivateQueryKey = () => ['private']

export const getOrdersQueryKey = (...keys: SalesKeys) => [
  ...getPrivateQueryKey(),
  'orders',
  ...keys,
]

export const getStocklistSourcesQueryKey = (...keys: StocklistSourcesKeys) => [
  ...getPrivateQueryKey(),
  'stocklistSources',
  ...keys,
]

export const getStocklistSourceQueryKey = (...keys: StocklistSourceKeys) => [
  ...getPrivateQueryKey(),
  'stocklist-source',
  ...keys,
]

export const getStocklistSourceNamesQueryKey = (filterExpired?: boolean) => [
  ...getPrivateQueryKey(),
  'stocklist-source-names',
  filterExpired,
]

export const getStocklistSourceOffersQueryKey = (
  ...keys: StocklistSourceOffersKeys
) => [...getPrivateQueryKey(), 'stocklist-source-offers', ...keys]
